import React from 'react';
import './PTS.css';
import FMSimage from '../Assets/Picture1 person.jpg'; // First image
import FMSimage2 from '../Assets/Picture1 person2.png'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/pts2.jpeg'; // Image for How it Works section
import FMSimage4 from '../Assets/pt3.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/pts4.jpg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-card">
            <div className="FMS-container">
                {/* First Section: Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <h1 className="FMS-heading">ASSET TRACKING SYSTEM</h1>
                        <p className="FMS-description">
                            The Asset Tracking System from Vajra IoT leverages GPS/RF and 2.4GHz RFID technology to provide real-time notifications for asset addition and movement. This fixed asset tracking solution streamlines audits, enhances security, and supports RTLS applications for precise asset and personnel management.
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage} alt="Asset Tracking System" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading Between Images */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
                </div>

                {/* Second Section: New Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>GPS/RF Tracking:</strong> Innovative devices for real-time asset and personnel tracking.</li>
                                <li><strong>2.4GHz RFID Reader & Active Tag:</strong> Enables precise tracking and signaling.</li>
                                <li><strong>Asset & Personnel Tracking:</strong> Monitors assets and individuals with exact location data.</li>
                                <li><strong>Building Security & Access Control:</strong> Enhances security with RFID-based access systems.</li>
                                <li><strong>RTLS Applications:</strong> Supports warehouse management, logistics, and signaling systems.</li>
                                <li><strong>Real-Time Notifications:</strong> Alerts for asset addition, movement, or exigencies.</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: New Image for Key Features */}
                    <div className="FMS-image-container">
                        <img src={FMSimage2} alt="Key Features" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading for How it Works */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">How it Works</h2>
                </div>

                {/* Third Section: Layout for How it Works */}
                <div className="FMS-content-container">
                    {/* Left side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage3} alt="How It Works" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            GPS/RF devices and 2.4GHz RFID readers with active tags track assets and personnel in real time. The system sends notifications for asset addition, movement, or exigencies, supporting RTLS applications like warehouse management and logistics. Data is accessible via a dashboard, facilitating smooth audits and integrating with security and access control systems.
                        </p>
                    </div>
                </div>

                {/* New Section: Why Choose Us */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Why Choose Our Asset Tracking System</h2>
                </div>

                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>Audit Efficiency:</strong> Streamlines fixed asset tracking for smooth audits.</li>
                                <li><strong>Enhanced Security:</strong> Integrates with access control for building safety.</li>
                                <li><strong>Precise Location Tracking:</strong> Delivers exact asset and personnel locations.</li>
                                <li><strong>RTLS Versatility:</strong> Supports diverse applications like logistics and warehouse management.</li>
                                <li><strong>Real-Time Alerts:</strong> Ensures timely response to asset movements or emergencies.</li>
                            </ul>
                        </p>
                    </div>

                    {/* Rightiny side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage4} alt="Why Choose Asset Tracking" className="FMS-image" />
                    </div>
                </div>

                {/* New Section: Industries Using Our System */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Industries Using Our Asset Tracking System</h2>
                </div>

                <div className="FMS-content-container reverse-order-last">
                    {/* Left side: Image for Industries */}
                    <div className="FMS-image-container">
                        <img src={FMSimage5} alt="Industries Using Asset Tracking" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            Our Asset Tracking System is trusted across industries for its precision, security, and efficiency. These sectors rely on our solution for real-time asset and personnel management:
                            <ul>
                                <li>Warehousing & Logistics</li>
                                <li>Manufacturing</li>
                                <li>Healthcare</li>
                                <li>Construction</li>
                                <li>Corporate Facilities</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FMS;